import React, { useEffect, useState } from 'react'
import { useParams, NavLink } from 'react-router-dom'
import Layout from '../components/Layout'
import BlogRenderer from '../components/BlogRenderer'
import ContactButtons, { outline } from '../components/ContactButtons'
import NotFound from './NotFound'

export default function BlogPost() {
  const { slug } = useParams()
  // undefined while loading, null when the slug doesn't match a post
  const [post, setPost] = useState(undefined)

  useEffect(() => {
    window.scrollTo(0, 0)
    fetch('/blogData.json')
      .then((res) => res.json())
      .then((posts) => setPost(posts.find((p) => p.slug === slug) ?? null))
      .catch(() => setPost(null))
  }, [slug])

  if (post === null) return <NotFound />

  return (
    <Layout title={post?.title}>
      {post && (
        <article className='max-w-3xl mx-auto'>
          <h1 className='lg:text-4xl text-3xl font-bold mb-2 text-center'>
            {post.title}
          </h1>
          <div className='text-sm text-gray-500 mb-6 block w-max mx-auto pt-2'>
            {post.date}
          </div>
          <BlogRenderer content={post.content} />

          <ContactButtons className='mt-12'>
            <NavLink to='/blog' className={outline}>
              view all posts
            </NavLink>
          </ContactButtons>
        </article>
      )}
    </Layout>
  )
}
